// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select-area[data-v-d83dbdb6]{position:relative}.opaque[data-v-d83dbdb6]{opacity:.5}.overlay[data-v-d83dbdb6]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.usual-power-error>label[data-v-d83dbdb6]{width:100%;margin-bottom:20px;text-align:center;font-size:13px;font-weight:600;color:red}", ""]);
// Exports
module.exports = exports;
